// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2iHqF","author":"Table_author__mD60O","authorImage":"Table_authorImage__2dNq2","unreadRow":"Table_unreadRow__30mC2"};